import { BacsPaymentForm } from 'components';
import ActionRequired from 'components/ActionRequired';
import AlternatingText from 'components/AlternatingText';

import CantFindBankButton from './CantFindBankButton';

import { useStatusDepositContext } from '../../context';

const StatusDepositBank: React.FunctionComponent = function () {
  const { job, subheading } = useStatusDepositContext();
  return (
    <div className="flex flex-col -mt-2">
      <div className="hidden md:flex flex-col">
        <ActionRequired />
      </div>
      <BacsPaymentForm
        job={job}
        title="Pay deposit using Open Banking"
        customHeading={
          <div className="mb-6 md:mb-8">
            <AlternatingText array={subheading} />
          </div>
        }
      />
      <CantFindBankButton />
    </div>
  );
};

export default StatusDepositBank;
